// extracted by mini-css-extract-plugin
export default {"TrueBlack":"#000000","spotlight":"Gb1deb1"};